import * as React from 'react'

export function OtherReading(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M24 11.004h-4a1 1 0 110-2h4a1 1 0 110 2zm0 5h-4a1 1 0 110-2h4a1 1 0 110 2zm0 5h-4a1 1 0 110-2h4a1 1 0 110 2zm-7 0a1 1 0 11-2 0v-11a1 1 0 112 0v11zm-5-10H8a1 1 0 110-2h4a1 1 0 110 2zm0 5H8a1 1 0 110-2h4a1 1 0 110 2zm0 5H8a1 1 0 110-2h4a1 1 0 110 2zM26.996 6H18c-1.021 0-2 1-2 1s-1.021-1-2-1H5.002C4.448 6 4 6.449 4 7.002V23c0 .555.449 1.004 1.004 1.004h7.008c1.969 0 1.975 2 2.988 2h2c1 0 1.027-2 3.006-2h6.989c.555 0 1.005-.45 1.005-1.005V7.004C28 6.449 27.551 6 26.996 6z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
